import { render, staticRenderFns } from "./dialog-show-slot.mpx?vue&type=template&id=7980c61c&isComponent&outputPath=components%2Fdialog-show-slot6f4c3e5b%2Findex"
import script from "./dialog-show-slot.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Fdialog-show-slot6f4c3e5b%2Findex"
export * from "./dialog-show-slot.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Fdialog-show-slot6f4c3e5b%2Findex"
import style0 from "./dialog-show-slot.mpx?vue&type=style&index=0&id=7980c61c&prod&lang=stylus&mpxStyleOptions=%7B%22mid%22%3A%22_6f4c3e5b%22%7D&isComponent&outputPath=components%2Fdialog-show-slot6f4c3e5b%2Findex"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports